import { copy } from "shared/assets";
import { IActionDropdownItem } from "shared/components";

const { actions: actionsCopy } = copy;

export const getEventSettingsActions = ({
  handleEdit,
}: {
  handleEdit: () => void;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [
    {
      label: actionsCopy.edit,
      handleClick: handleEdit,
      dataTestId: "edit_event_settings",
    },
  ];

  return actions;
};
